<template lang="pug">
  .b2b-filter-button-facturas-recibidas
    ods-tag(
      closable='',
      type='secondary',
      @close='closeTagFilter')
        span.b2b-filter-button__value {{ $t(filter.value) }} :
        span.b2b-filter-button__query {{ getLabel }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'

export default {
  name: 'b2b-filter-button-facturas-recibidas',

  props: {
    filter: {
      required: true,
      type: Object
    }
  },

  data () {
    return {
      filterListAfterRemove: []
    }
  },

  computed: {
    ...mapGetters([
      'queryReceivedPayrolls',
      'listSelectedFiltersReceivedPayrolls'
    ]),

    getLabel () {
      if (this.filter.col.includes('Date')) {
        return this.$d(this.filter.labelText[0]) + '-' + this.$d(this.filter.labelText[1])
      } else {
        return this.filter.labelText
      }
    }
  },

  methods: {
    ...mapActions([
      'getPayrolls',
      'queryReceivedPayrollsState',
      'listSelectedFiltersReceivedPayrollsState'
    ]),

    async closeTagFilter () {
      const dataQuery = {
        query: {}
      }
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.filter_delete')
      })
      this.filter.selected = false // eslint-disable-line
      this.filterListAfterRemove = this.listSelectedFiltersReceivedPayrolls.filter(item => item.prop !== this.filter.prop)
      switch (this.filter.prop) {
        case 'buyerId':
          this.queryReceivedPayrolls.buyerId = ''
          this.queryReceivedPayrolls.buyerGenericCentreId = ''
          this.queryReceivedPayrolls.buyerCentreId = ''
          this.queryReceivedPayrolls.deliveryCentreId = ''
          this.queryReceivedPayrolls.invoiceeCentreId = ''
          break
        case 'sellerId':
          this.queryReceivedPayrolls.sellerId = ''
          this.queryReceivedPayrolls.sellerCentreId = ''
          break
        case 'invoiceNumber':
          this.queryReceivedPayrolls.invoiceNumber = ''
          break
        case 'idProject':
          this.queryReceivedPayrolls.projectId = ''
          break
        case 'statusId':
          this.queryReceivedPayrolls.statusId = ''
          break
        case 'documentClassCode':
          this.queryReceivedPayrolls.documentClassCode = ''
          break
        case 'receptionMethodId':
          this.queryReceivedPayrolls.receptionMethodId = ''
          break
        case 'taxTypeCode':
          this.queryReceivedPayrolls.taxTypeCode = ''
          break
        case 'currencyId':
          this.queryReceivedPayrolls.currencyId = ''
          break
        case 'orderNumber':
          this.queryReceivedPayrolls.orderNumber = ''
          break
        case 'contract':
          this.queryReceivedPayrolls.contract = ''
          break
        case 'deliveryNote':
          this.queryReceivedPayrolls.deliveryNote = ''
          break
        case 'file':
          this.queryReceivedPayrolls.file = ''
          break
        case 'invoiceSeriesCode':
          this.queryReceivedPayrolls.invoiceSeriesCode = ''
          break
        case 'correctiveInvoiceNumber':
          this.queryReceivedPayrolls.correctiveInvoiceNumber = ''
          break
        case 'issueDates':
          this.queryReceivedPayrolls.issueDateFrom = ''
          this.queryReceivedPayrolls.issueDateTo = ''
          break
        case 'operationDates':
          this.queryReceivedPayrolls.operationDateFrom = ''
          this.queryReceivedPayrolls.operationDateTo = ''
          break
        case 'registerNumber':
          this.queryReceivedPayrolls.registerNumber = ''
          break
        case 'id':
          this.queryReceivedPayrolls.id = ''
          break
        case 'noErrorStatus':
          this.queryReceivedPayrolls.noErrorStatus = ''
          break
        case 'invoiceTypeId':
          this.queryReceivedPayrolls.invoiceTypeId = ''
          break
        case 'totalExecutableAmountFrom':
          this.queryReceivedPayrolls.totalExecutableAmountFrom = ''
          break
        case 'totalExecutableAmountTo':
          this.queryReceivedPayrolls.totalExecutableAmountTo = ''
          break
        case 'withAttachment':
          this.queryReceivedPayrolls.withAttachment = ''
          break
        case 'sent':
          this.queryReceivedPayrolls.sent = ''
          break
        case 'rate':
          this.queryReceivedPayrolls.rate = ''
          break
        case 'paymentMethod':
          this.queryReceivedPayrolls.paymentMethod = ''
          break
        case 'accountingDate':
          this.queryReceivedPayrolls.accountingDateFrom = ''
          this.queryReceivedPayrolls.accountingDateTo = ''
          break
        case 'paymentDate':
          this.queryReceivedPayrolls.paymentDateFrom = ''
          this.queryReceivedPayrolls.paymentDateTo = ''
          break
        case 'clientInvoiceNumber':
          this.queryReceivedPayrolls.clientInvoiceNumber = ''
          break
        default:
          break
      }

      try {
        await this.queryReceivedPayrollsState(this.queryReceivedPayrolls)

        const draftId = (this.$route.params && this.$route.params.draftId ? this.$route.params.draftId : null)
        if (draftId) {
          dataQuery.query = {
            ...dataQuery.query,
            ...this.queryReceivedPayrolls,
            draftId: draftId
          }
        } else {
          dataQuery.query = this.queryReceivedPayrolls
        }
        await this.getPayrolls(dataQuery)

        this.$emit('closeTag', { filter: this.filter, listAfterRemove: this.filterListAfterRemove })
      } catch (error) {
        console.log('closeTagFilter CATCH: ', error)
        let errorSms = ''
        let statusCode = null
        statusCode = error.status
        switch (statusCode) {
          case 400:
            errorSms = this.$t('error.e400')
            break
          case 401:
            errorSms = this.$t('error.e401')
            router.push({ name: 'login' })
            break
          case 500:
            errorSms = this.$t('error.e500')
            break
          default:
            errorSms = this.$t('error.default')
            break
        }
        this.$notify({
          title: errorSms,
          type: 'error',
          position: 'top-right',
          customClass: 'b2b-notification-error',
          duration: 10000
        })
      } finally {
        load.close()
      }
    }
  }
}
</script>

<style lang="scss" scoped>

</style>
